import { render, staticRenderFns } from "./Panacomlibros.vue?vue&type=template&id=33b96c5d&scoped=true&"
import script from "./Panacomlibros.vue?vue&type=script&lang=js&"
export * from "./Panacomlibros.vue?vue&type=script&lang=js&"
import style0 from "./Panacomlibros.vue?vue&type=style&index=0&id=33b96c5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b96c5d",
  null
  
)

export default component.exports